var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3283_4269)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#E6E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5C10.1591 5 8.66667 6.49238 8.66667 8.33333C8.66667 10.1743 10.1591 11.6667 12 11.6667C13.8409 11.6667 15.3333 10.1743 15.3333 8.33333C15.3333 6.49238 13.8409 5 12 5ZM10 8.33333C10 7.22876 10.8954 6.33333 12 6.33333C13.1046 6.33333 14 7.22876 14 8.33333C14 9.4379 13.1046 10.3333 12 10.3333C10.8954 10.3333 10 9.4379 10 8.33333Z",
    fill: "#F8009E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 13C8.44928 13 7.60143 13.3512 6.97631 13.9763C6.35119 14.6014 6 15.4493 6 16.3333V17.6667C6 18.0349 6.29848 18.3333 6.66667 18.3333C7.03486 18.3333 7.33333 18.0349 7.33333 17.6667V16.3333C7.33333 15.8029 7.54405 15.2942 7.91912 14.9191C8.29419 14.544 8.8029 14.3333 9.33333 14.3333H14.6667C15.1971 14.3333 15.7058 14.544 16.0809 14.9191C16.456 15.2942 16.6667 15.8029 16.6667 16.3333V17.6667C16.6667 18.0349 16.9651 18.3333 17.3333 18.3333C17.7015 18.3333 18 18.0349 18 17.6667V16.3333C18 15.4493 17.6488 14.6014 17.0237 13.9763C16.3986 13.3512 15.5507 13 14.6667 13H9.33333Z",
    fill: "#F8009E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3283_4269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.54d6763ad438ef8f4f94411ed45ddace.svg";
export { ForwardRef as ReactComponent };